import React, {useEffect, useState} from 'react';
import { useNavigate } from 'react-router-dom';
import HeaderTopSection from "../../components/partials/HeaderTop";
import Footer from "../../components/partials/Footer";
import LoadingSpinner from "../../utils/LoadingSpinner";

const AideDomicile = () => {
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        // Simuler le chargement des ressources
        const timer = setTimeout(() => {
            setIsLoading(false);
        }, 3000);

        return () => clearTimeout(timer);
    }, []);

    // Vérifier si l'utilisateur est connecté
    const isUserLoggedIn = () => {
        // Vérifier la présence d'un token ou d'infos utilisateur dans le localStorage/sessionStorage
        const token = localStorage.getItem('token') || sessionStorage.getItem('token');
        const user = localStorage.getItem('user') || sessionStorage.getItem('user');
        return !!(token || user);
    };

    // Gérer la redirection après clic sur un bouton
    const handleProfessionalRedirect = () => {
        if (isUserLoggedIn()) {
            navigate('/professional-candidate');
        } else {
            navigate('/professionals');
        }
    };

    return (
        <>

            {/* Affichage du spinner de chargement */}
            <LoadingSpinner
                isVisible={isLoading}
                loadingText="Chargement de la page..."
            />

            <HeaderTopSection/>

            <main className="main overflow-hidden">

                {/* Hero Section */}
                <section className="hero-section bg-gradient-primary py-xxl-25 py-20 position-relative overflow-hidden">
                    <div className="container position-relative z-1">
                        <div className="row align-items-center justify-content-lg-between justify-content-center">
                            <div className="col-xxl-6 col-xl-5 col-lg-5 col-md-8">
                                <div className="hero-content text-lg-start text-center">
                                    <div className="section-title">
                                        <div className="badge-section mb-4 aos-init aos-animate" data-aos="fade-up" data-aos-duration="800">
                                            <span className="badge bg-white text-primary fw-700 fs-15 px-4 py-2 rounded-pill shadow-sm">
                                                🏠 AIDE À DOMICILE
                                            </span>
                                        </div>
                                        <h1 className="text-white fw-800 mb-xxl-6 mb-xl-5 mb-4 aos-init aos-animate" data-aos="fade-up" data-aos-duration="1000">
                                            Soins aux personnes âgées<br/>
                                            <span className="text-warning">l'aide adéquate pour les proches</span>
                                        </h1>
                                        <p className="text-light fs-20 mb-5 aos-init aos-animate" data-aos="fade-up" data-aos-duration="1200">
                                            Des professionnels qualifiés et bienveillants pour accompagner vos proches dans leur quotidien
                                        </p>
                                        <div className="hero-features aos-init aos-animate" data-aos="fade-up" data-aos-duration="1400">
                                            <div className="d-flex flex-wrap gap-3 justify-content-lg-start justify-content-center">
                                                <div className="feature-tag bg-white bg-opacity-25 text-white px-4 py-2 rounded-pill fs-15 fw-600">
                                                    ✅ Professionnels qualifiés
                                                </div>
                                                <div className="feature-tag bg-white bg-opacity-25 text-white px-4 py-2 rounded-pill fs-15 fw-600">
                                                    ⏱️ Disponibilité 7j/7
                                                </div>
                                                <div className="feature-tag bg-white bg-opacity-25 text-white px-4 py-2 rounded-pill fs-15 fw-600">
                                                    💝 Accompagnement personnalisé
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xxl-6 col-xl-5 col-lg-5">
                                <div className="hero-image position-relative aos-init aos-animate"
                                     data-aos="zoom-in" data-aos-duration="1500">
                                    <div className="floating-elements">
                                        <div className="floating-card card1 bg-white shadow-lg rounded-4 p-4 position-absolute">
                                            <div className="d-flex align-items-center gap-3">
                                                <div className="icon-circle bg-primary text-white rounded-circle d-flex align-items-center justify-content-center">
                                                    ⭐
                                                </div>
                                                <div>
                                                    <h6 className="fw-700 mb-1">4.8/5</h6>
                                                    <small className="text-muted fs-14">Satisfaction clients</small>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="floating-card card2 bg-white shadow-lg rounded-4 p-4 position-absolute">
                                            <div className="d-flex align-items-center gap-3">
                                                <div className="icon-circle bg-success text-white rounded-circle d-flex align-items-center justify-content-center">
                                                    👥
                                                </div>
                                                <div>
                                                    <h6 className="fw-700 mb-1">300+</h6>
                                                    <small className="text-muted fs-14">Aidants disponibles</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <img src="assets/images/service/aide-a-domicile/hero-aide-domicile.jpg"
                                         alt="Aidante à domicile avec une personne âgée"
                                         className="img-fluid rounded-4 shadow-lg"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="wave-bg"></div>
                </section>

                {/* Section Processus */}
                <section className="process-section py-xxl-25 py-20 bg-light">
                    <div className="container">
                        <div className="row justify-content-center mb-xxl-15 mb-xl-10 mb-8">
                            <div className="col-lg-8 text-center">
                                <div className="">
                                    <h2 className="fw-800 text-dark mb-4 fs-32">
                                        Trouvez votre aidant en 3 étapes simples
                                    </h2>
                                </div>
                                <p className="text-muted fs-20">
                                    Notre plateforme facilite la mise en relation avec des professionnels de confiance
                                </p>
                            </div>
                        </div>
                        <div className="row g-4 justify-content-center">
                            <div className="col-lg-4 col-md-6">
                                <div className="process-card card border-0 shadow-sm h-100 text-center p-5 rounded-4 aos-init aos-animate"
                                     data-aos="fade-up" data-aos-duration="800">
                                    <div className="process-number bg-primary text-white rounded-circle d-inline-flex align-items-center justify-content-center mb-4 mx-auto fw-800">
                                        1
                                    </div>
                                    <h5 className="fw-700 mb-3 fs-18">Définissez vos besoins</h5>
                                    <p className="text-muted fs-16">
                                        Précisez le type d'aide requis : soins, ménage, compagnie, et vos disponibilités
                                    </p>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                                <div className="process-card card border-0 shadow-sm h-100 text-center p-5 rounded-4 aos-init aos-animate"
                                     data-aos="fade-up" data-aos-duration="1000">
                                    <div className="process-number bg-primary text-white rounded-circle d-inline-flex align-items-center justify-content-center mb-4 mx-auto fw-800">
                                        2
                                    </div>
                                    <h5 className="fw-700 mb-3 fs-18">Soumettez votre demande</h5>
                                    <p className="text-muted fs-16">
                                        Transmettez vos critères via notre plateforme qui sélectionne les profils correspondants
                                    </p>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                                <div className="process-card card border-0 shadow-sm h-100 text-center p-5 rounded-4 aos-init aos-animate"
                                     data-aos="fade-up" data-aos-duration="1200">
                                    <div className="process-number bg-primary text-white rounded-circle d-inline-flex align-items-center justify-content-center mb-4 mx-auto fw-800">
                                        3
                                    </div>
                                    <h5 className="fw-700 mb-3 fs-18">Rencontrez votre aidant</h5>
                                    <p className="text-muted fs-16">
                                        Notre équipe vous met en relation avec le professionnel sélectionné pour un accompagnement serein
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="row justify-content-center mt-6">
                            <div className="col-lg-8 text-center">
                                <div className="bg-white rounded-4 p-4 shadow-sm">
                                    <p className="text-primary fw-600 fs-16 mb-0">
                                        💡 <strong>Notre engagement :</strong> Des professionnels vérifiés pour la sécurité et le bien-être de vos proches
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Section Accompagnement sur mesure */}
                <section className="services-section py-xxl-25 py-20">
                    <div className="container">
                        <div className="row justify-content-center mb-xxl-15 mb-xl-10 mb-8">
                            <div className="col-lg-8 text-center">
                                <div className="">
                                    <h2 className="fw-800 text-dark mb-4 fs-32">
                                        Un accompagnement sur mesure
                                    </h2>
                                    <p className="text-muted fs-20">
                                        Des solutions adaptées aux besoins spécifiques de chaque personne
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Service 1 - Accompagnement personnalisé */}
                        <section className="service-card card border-0 shadow-lg mb-6 rounded-4 overflow-hidden">
                            <div className="container p-12">
                                <div className="row g-6 align-items-md-center justify-content-between">
                                    <div className="col-lg-5 col-md-6 col-sm-6">
                                        <div className="quick-thumb w-100 overflow-hidden aos-init aos-animate"
                                             data-aos="zoom-in-right" data-aos-duration="1500"
                                             style={{borderRadius: '10%'}}>
                                            <img
                                                src="assets/images/service/aide-a-domicile/accompagnement-personnalise.jpg"
                                                alt="Accompagnement personnalisé" className="w-100"/>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-6">
                                        <div className="quick-content">
                                            <div className="service-icon bg-primary bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-4">
                                                💝
                                            </div>
                                            <h3 className="fw-800 text-dark mb-4 fs-28">Accompagnement personnalisé</h3>

                                            <p className="text-muted fs-16 mb-4">
                                                L'accompagnement sur mesure proposé par Driven Home Services est conçu pour répondre aux besoins spécifiques des personnes âgées, en tenant compte de leur état de santé, de leurs habitudes de vie, et de leurs préférences.
                                            </p>

                                            <div className="mb-4">
                                                <h6 className="fw-700 text-dark mb-3 fs-17">Nos atouts :</h6>
                                                <ul className="text-muted fs-16">
                                                    <li className="mb-2">• <strong>Flexibilité :</strong> Prestations ponctuelles ou régulières, au quotidien ou occasionnelles</li>
                                                    <li className="mb-2">• <strong>Qualification :</strong> Professionnels diplômés (AVS, BEP sanitaire et social)</li>
                                                    <li className="mb-2">• <strong>Disponibilité :</strong> Service 24h/24 et 7j/7 pour les besoins urgents</li>
                                                </ul>
                                            </div>

                                            <p className="text-muted fs-16 mb-4">
                                                Pour en savoir plus sur nos professionnels d'aide à domicile et de soutien à la personne âgée, choisissez en toute confiance parmi nos profils vérifiés.
                                            </p>

                                            <ul className="service-features list-unstyled mb-4">
                                                <li className="d-flex align-items-center gap-3 mb-3">
                                                    <span className="text-success fs-18">✅</span>
                                                    <span className="fs-16">Interventions sur mesure</span>
                                                </li>
                                                <li className="d-flex align-items-center gap-3 mb-3">
                                                    <span className="text-success fs-18">✅</span>
                                                    <span className="fs-16">Profils vérifiés et qualifiés</span>
                                                </li>
                                                <li className="d-flex align-items-center gap-3 mb-3">
                                                    <span className="text-success fs-18">✅</span>
                                                    <span className="fs-16">Disponibilité étendue</span>
                                                </li>
                                            </ul>

                                            <button
                                                onClick={handleProfessionalRedirect}
                                                className="btn btn-primary fw-600 px-5 py-3 rounded-pill fs-16">
                                                Découvrir nos accompagnants
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        {/* Service 2 - Aides du quotidien */}
                        <div className="service-card card border-0 shadow-lg mb-6 rounded-4 overflow-hidden">
                            <div className="row g-0 align-items-center flex-lg-row-reverse">
                                <div className="col-lg-6 pb-12">
                                    <div className="p-xxl-8 p-xl-6 p-5">
                                        <div className="service-icon bg-warning bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-4">
                                            🏡
                                        </div>
                                        <h3 className="fw-800 text-dark mb-4 fs-28">Aides au quotidien</h3>

                                        <p className="text-muted fs-16 mb-4">
                                            Des services complets pour faciliter le quotidien des personnes âgées et maintenir leur autonomie à domicile.
                                        </p>

                                        <div className="mb-4">
                                            <h6 className="fw-700 text-dark mb-3 fs-17">Nos services inclus :</h6>
                                            <ul className="text-muted fs-16">
                                                <li className="mb-2">• <strong>Aide ménagère :</strong> Entretien du domicile, ménage, repassage et rangement</li>
                                                <li className="mb-2">• <strong>Aide à l'hygiène :</strong> Assistance pour la toilette, l'habillage et les soins corporels</li>
                                                <li className="mb-2">• <strong>Préparation des repas :</strong> Cuisine de plats équilibrés adaptés aux besoins</li>
                                                <li className="mb-2">• <strong>Aide aux courses :</strong> Accompagnement ou gestion complète des achats</li>
                                                <li className="mb-2">• <strong>Mobilité :</strong> Aide aux déplacements et accompagnement aux rendez-vous</li>
                                            </ul>
                                        </div>

                                        <p className="text-muted fs-16 mb-4">
                                            Chaque intervention est adaptée aux capacités et préférences de la personne accompagnée.
                                        </p>

                                        <ul className="service-features list-unstyled mb-4">
                                            <li className="d-flex align-items-center gap-3 mb-3">
                                                <span className="text-success fs-18">✓</span>
                                                <span className="fs-16">Services complets et modulables</span>
                                            </li>
                                            <li className="d-flex align-items-center gap-3 mb-3">
                                                <span className="text-success fs-18">✓</span>
                                                <span className="fs-16">Respect de l'autonomie</span>
                                            </li>
                                            <li className="d-flex align-items-center gap-3 mb-3">
                                                <span className="text-success fs-18">✓</span>
                                                <span className="fs-16">Adaptation aux besoins spécifiques</span>
                                            </li>
                                        </ul>
                                        <button
                                            onClick={handleProfessionalRedirect}
                                            className="btn btn-warning text-white fw-600 px-5 py-3 rounded-pill fs-16">
                                            Voir les services disponibles
                                        </button>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <img
                                        src="assets/images/service/aide-a-domicile/aides-quotidien.jpg"
                                        alt="Aides du quotidien"
                                        className="img-fluid h-100 object-fit-cover"/>
                                </div>
                            </div>
                        </div>

                        {/* Service 3 - Services spécialisés */}
                        <section className="service-card card border-0 shadow-lg rounded-4 overflow-hidden">
                            <div className="container">
                                <div className="row g-6 align-items-md-center justify-content-between">
                                    <div className="col-lg-6 col-md-6 col-sm-6 p-12">
                                        <div className="quick-content">
                                            <div className="service-icon bg-success bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-4">
                                                👵
                                            </div>
                                            <h3 className="fw-800 text-dark mb-4 fs-28">Services spécialisés</h3>

                                            <p className="text-muted fs-16 mb-4">
                                                Des solutions spécifiques pour répondre aux différents besoins d'accompagnement des personnes âgées.
                                            </p>

                                            <div className="mb-4">
                                                <h6 className="fw-700 text-dark mb-3 fs-17">Dames de compagnie</h6>
                                                <p className="text-muted fs-16 mb-3">
                                                    Professionnelles qualifiées pour offrir compagnie et soutien aux personnes âgées ou isolées.
                                                    Elles partagent des moments de convivialité : conversations, jeux, promenades et activités extérieures.
                                                </p>
                                            </div>

                                            <div className="mb-4">
                                                <h6 className="fw-700 text-dark mb-3 fs-17">Auxiliaires de vie</h6>
                                                <p className="text-muted fs-16 mb-3">
                                                    Accompagnement personnalisé pour les personnes âgées, en situation de handicap ou dépendantes.
                                                    Aide complète pour les tâches ménagères, soins d'hygiène, préparation des repas,
                                                    gestion des médicaments et accompagnement lors des déplacements.
                                                </p>
                                            </div>

                                            <p className="text-muted fs-16 mb-4">
                                                Tous nos professionnels sont sélectionnés pour leurs compétences et leur bienveillance.
                                            </p>

                                            <ul className="service-features list-unstyled mb-4">
                                                <li className="d-flex align-items-center gap-3 mb-3">
                                                    <span className="text-success fs-18">✅</span>
                                                    <span className="fs-16">Dames de compagnie qualifiées</span>
                                                </li>
                                                <li className="d-flex align-items-center gap-3 mb-3">
                                                    <span className="text-success fs-18">✅</span>
                                                    <span className="fs-16">Auxiliaires de vie diplômés</span>
                                                </li>
                                                <li className="d-flex align-items-center gap-3 mb-3">
                                                    <span className="text-success fs-18">✅</span>
                                                    <span className="fs-16">Soutien global et personnalisé</span>
                                                </li>
                                            </ul>

                                            <button
                                                onClick={handleProfessionalRedirect}
                                                className="btn btn-success fw-600 px-5 py-3 rounded-pill fs-16">
                                                Consulter les profils
                                            </button>
                                        </div>
                                    </div>
                                    <div className="col-lg-5 col-md-6 col-sm-6">
                                        <div className="quick-thumb w-100 overflow-hidden aos-init aos-animate"
                                             data-aos="zoom-in-right" data-aos-duration="1500"
                                             style={{borderRadius: '10%'}}>
                                            <img src="assets/images/service/aide-a-domicile/services-specialises.jpg" alt="Services spécialisés" className="w-100"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </section>

                {/* Section CTA */}
                <section className="cta-section bg-primary py-xxl-25 py-20">
                    <div className="container">
                        <div className="row justify-content-center text-center">
                            <div className="col-lg-8">
                                <h2 className="text-white fw-800 mb-4 fs-32">
                                    Offrez un accompagnement de qualité à vos proches
                                </h2>
                                <p className="text-light mb-5 fs-20">
                                    Des professionnels de confiance pour la sérénité de toute la famille
                                </p>
                                <div className="d-flex flex-wrap gap-4 justify-content-center">
                                    <button
                                        onClick={handleProfessionalRedirect}
                                        className="btn btn-success fw-600 px-5 py-3 rounded-pill fs-16">
                                        Trouver un aidant
                                    </button>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </main>

            <Footer/>

            <style jsx>{`
                .bg-gradient-primary {
                    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                }

                .wave-bg {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    width: 100%;
                    height: 100px;
                    background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1200 120' preserveAspectRatio='none'%3E%3Cpath d='M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z' fill='white'%3E%3C/path%3E%3C/svg%3E");
                    background-size: cover;
                    background-position: center;
                }

                .hero-image {
                    position: relative;
                }

                .floating-card {
                    z-index: 2;
                }

                .card1 {
                    top: 20px;
                    left: -20px;
                    animation: float 3s ease-in-out infinite;
                }

                .card2 {
                    bottom: 20px;
                    right: -20px;
                    animation: float 3s ease-in-out infinite 1.5s;
                }

                .icon-circle {
                    width: 40px;
                    height: 40px;
                    font-size: 18px;
                }

                .process-number {
                    width: 60px;
                    height: 60px;
                    font-size: 24px;
                    font-weight: bold;
                }

                .service-icon {
                    width: 80px;
                    height: 80px;
                    font-size: 32px;
                }

                @keyframes float {
                    0%, 100% { transform: translateY(0); }
                    50% { transform: translateY(-10px); }
                }

                .service-card img {
                    transition: transform 0.3s ease;
                }

                .service-card:hover img {
                    transform: scale(1.05);
                }

                .btn {
                    transition: all 0.3s ease;
                }

                .btn:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 8px 25px rgba(0,0,0,0.15);
                }

                /* Améliorations typographiques */
                .fs-14 { font-size: 14px; }
                .fs-15 { font-size: 15px; }
                .fs-16 { font-size: 16px; }
                .fs-17 { font-size: 17px; }
                .fs-18 { font-size: 18px; }
                .fs-20 { font-size: 20px; }
                .fs-28 { font-size: 28px; }
                .fs-32 { font-size: 32px; }

                .fw-600 { font-weight: 600; }
                .fw-700 { font-weight: 700; }
                .fw-800 { font-weight: 800; }
            `}</style>
        </>
    );
};

export default AideDomicile;